import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function PrivateRoute({ children }) {
    const { user, loading } = useAuth();

    console.log("user:", user);
    console.log("loading:", loading);

    if (loading) {
        return <p>Carregando...</p>;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return children;
}